import {
  Button,
  Drawer,
  DrawerBody,
  DrawerCloseButton,
  DrawerContent,
  DrawerHeader,
  DrawerOverlay,
  FormControl,
  FormLabel,
  Icon,
  Spinner,
  Text,
  useDisclosure,
  useToast,
} from '@chakra-ui/react';
import React, { useState } from 'react';
import { Stack } from '@chakra-ui/layout';
import { useForm } from 'react-hook-form';
import { FiChevronLeft } from 'react-icons/fi';
import { Textarea } from '~/components';
import { queryClient } from '~/utils/react-query';
import apiSinister from '~/utils/apiSinister';
import { useDebitNoteConfiguration } from '~/hooks/useSinisters/useSinisters';

export const SinistersEditTextForm: React.FC<{
  sinisterId: number;
}> = ({ sinisterId }) => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const btnRef = React.useRef(null);
  const toast = useToast();
  const {
    register,
    handleSubmit,
    setValue,
    reset,
    setError,
    formState,
    clearErrors,
    control,
  } = useForm();
  const { errors } = formState;
  const [isFetching, setFetching] = useState(false);
  ('');

  const [texto, setTexto] = useState<string>('');
  const { data: configuration } = useDebitNoteConfiguration();

  const handleOpen = () => {
    if (configuration) {
      setTexto(configuration.nota_de_debito_texto_padrao);
    }
    onOpen();
  };

  const handleClose = () => {
    clearValues();
    onClose();
  };
  const clearValues = () => {
    setTexto('');
    clearErrors();
  };

  async function handleCreate() {
    clearErrors();

    (!texto || !texto.trim().length) &&
      setError('texto', {
        type: 'required',
        message: 'Texto padrão é obrigatório',
      });

    texto.length > 255 &&
      setError('texto', {
        type: 'maxLength',
        message: 'Texto padrão com mais de 255 caracteres',
      });

    const { _formState } = control;
    if (!_formState.isValid) return;

    const form = { nota_de_debito_texto_padrao: texto };

    setFetching(true);

    const request = apiSinister.post(
      `configuracao/nota-debito/texto-padrao/`,
      form,
    );

    request
      .then(() => {
        toast({
          title: `Texto padrão alterado`,
          status: 'success',
          duration: 3000,
          isClosable: true,
          position: 'top-right',
        });
        clearValues();
        onClose();
        queryClient.invalidateQueries('sinisterDebitNoteConfiguration');
      })
      .catch(error => {
        if (error.response.status === 403) {
          toast({
            title: 'Usuário sem permissão',
            description: 'Sem permissão para execução da operação.',
            status: 'error',
            duration: 3000,
            isClosable: true,
            position: 'top-right',
          });
        } else if (error.response.status === 413) {
          toast({
            title: `Tamanho de requisição excedida`,
            description: 'Limite máximo para tamanho de arquivos é de 5MB',
            status: 'error',
            duration: 3000,
            isClosable: true,
            position: 'top-right',
          });
        } else if (error.response.status === 400) {
          // erros de valid

          const errorsValidate = Object.entries(error.response.data);

          errorsValidate.forEach(err => {
            console.log(err[0]);
            toast({
              title: `Erros ao alterar texto padrão`,
              description: String(err[1]),
              status: 'error',
              duration: 3000,
              isClosable: true,
              position: 'top-right',
            });
          });
        } else {
          toast({
            title: `Erro ao alterar texto padrão`,
            description: 'Tente novamente',
            status: 'error',
            duration: 3000,
            isClosable: true,
            position: 'top-right',
          });
        }
      })
      .finally(() => {
        setFetching(false);
      });
  }

  function handleTexto(e: any) {
    setTexto(e.target.value);
    if (e.target.value.length <= 255) {
      clearErrors('texto');
    }
  }

  return (
    <>
      <Text
        fontSize="14px"
        fontWeight="500"
        float="right"
        marginTop="5px"
        onClick={handleOpen}
        cursor="pointer"
      >
        Editar texto padrão
      </Text>
      <Drawer
        isOpen={isOpen}
        placement="right"
        onClose={handleClose}
        size="lg"
        closeOnOverlayClick={!isFetching}
      >
        <DrawerOverlay />
        <DrawerContent borderTopLeftRadius="md">
          <DrawerCloseButton isDisabled={isFetching} />
          <DrawerHeader>
            <Icon
              as={FiChevronLeft}
              style={{
                cursor: 'pointer',
                fontSize: '28px',
                marginRight: '10px',
              }}
              onClick={handleClose}
            />
            Texto padrão nota de débito
          </DrawerHeader>
          <DrawerBody>
            <Stack gridGap={6} bg="white" maxW={600} w="100%">
              <Stack gridGap={4}>
                <FormControl isInvalid={errors.texto}>
                  <FormLabel htmlFor="writeUpFile" style={{ fontSize: '14px' }}>
                    Alterar texto padrão
                  </FormLabel>
                  <Textarea
                    name="texto"
                    resize="none"
                    error={errors?.texto}
                    value={texto}
                    onChange={e => handleTexto(e)}
                    fontSize="15px"
                    placeholder="Alterar texto padrão"
                    isDisabled={isFetching}
                  />
                </FormControl>
              </Stack>
            </Stack>
            <Button
              type="submit"
              onClick={handleSubmit(handleCreate)}
              color="white"
              background="gray.900"
              _hover={{
                bgColor: 'black',
              }}
              style={{ marginTop: '20px' }}
              isDisabled={isFetching}
            >
              Confirmar{' '}
              {isFetching && <Spinner style={{ marginLeft: '10px' }} />}
            </Button>
            <Button
              type="submit"
              onClick={handleClose}
              color="black"
              background="transparent"
              style={{
                marginTop: '20px',
                marginLeft: '10px',
              }}
              isDisabled={isFetching}
            >
              Cancelar
            </Button>
          </DrawerBody>
        </DrawerContent>
      </Drawer>
    </>
  );
};
